<h2 mat-dialog-title>
    Fach {{ data?.id ? 'bearbeiten' : 'anlegen' }}
</h2>

<div class="pixl-form">
    <mat-dialog-content [formGroup]="form" class="grid">

        <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input matInput required formControlName="name" />
            <mat-error>{{ checkForErrors(form.controls["name"]) }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Anwendung</mat-label>
            <mat-select formControlName="region">
                <mat-option value="-1">Keine Region</mat-option>
                @for (country of countries; track country) {
                    <mat-option value="{{ country }}">
                        {{ country | transloco }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">
            Speichern
        </button>
    </mat-dialog-actions>
</div>